import React from 'react'
import styled from 'styled-components'
import { mq, spacing } from '../../../src/core/theme'

const MediaPartner = () => {
    return (
        <Container>
            <div>Media partner:</div>
            <Link href="https://thisweekinreact.com/?utm_source=state_of_rn">
                <img src={`/images/twir_logo.png`} alt="" width="48px" height="48px" />
                <b>This Week In React - Keeps you informed on everything React-Native!</b>
            </Link>
        </Container>
    )
}

const Link = styled.a`
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    @media ${mq.small} {
        margin-bottom: ${spacing(1)};
    }
`

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`

export default MediaPartner
